import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarTaskApi } from "../../http/carTasks/api";
import ModalDialog from "../ui/ModalDialog";

interface DeleteCarTaskDialogProps {
  carTaskId: string;
  carId: string;
  onClose: (success: boolean) => void;
  workflowId?: string;
}

const DeleteCarTaskDialog: FC<DeleteCarTaskDialogProps> = ({ carTaskId, carId, onClose, workflowId }) => {
  const i18n = useI18n();
  const carTasksApi = useCarTaskApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={() => onClose(false)}
      title={i18n.t.tasks.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: () => onClose(false),
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carTasksApi
              .deleteCarTask(carTaskId, carId, !!workflowId)
              .then(() => {
                onClose(false);
                dispatch(showSuccessNotification(i18n.t));
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {workflowId ? i18n.t.carTasks.questions.deleteWithWorkflow : i18n.t.carTasks.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarTaskDialog;
